const calculateDriverStats = (rides) => {
  function getMinutesRemaining(targetTime) {
    const now = new Date(); // Aktuální čas
  
    // Převedeme zadaný čas na Date objekt
    const [time, date] = targetTime.split(" "); // Rozdělíme čas a datum
    const [hours, minutes] = time.split(":").map(Number); // Získáme hodiny a minuty
    const [day, month, year] = date.split(".").map(Number); // Získáme den, měsíc a rok
  
    // Vytvoříme nový Date objekt pro zadaný čas
    const target = new Date(year, month - 1, day, hours, minutes);
  
    // Zjistíme rozdíl v milisekundách
    const differenceInMs = target - now;
  
    // Převedeme rozdíl na minuty
    const minutesRemaining = Math.floor(differenceInMs / 1000 / 60);
  
    return minutesRemaining;
  }

    // Funkce pro výpočet času cesty tam a zpět
    const calculateRoundTripTime = (distance) => {
      return (distance / 1000) * 1.6; // Převedeme metry na kilometry a spočítáme tam a zpět
    };

    const addMinutesToDate = (date, minutes) => {

      const result = new Date(date);
      result.setMinutes(result.getMinutes() + minutes);
      return result;
    };

    // Funkce pro formátování data na požadovaný formát "HH:MM DD.MM.YYYY"
    const formatDate = (date) => {
      const d = new Date(date);
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0'); // Měsíce jsou indexované od 0
      const year = d.getFullYear();
      return `${hours}:${minutes} ${day}.${month}.${year}`;
    };

    // Vyfiltrujeme pouze jízdy se statusem 2 nebo 3
    const filteredRides = rides.filter(
      (ride) => Number(ride.status) === 2 || Number(ride.status) === 3 || Number(ride.status) === 4
    );

    // Pro každého řidiče uchováme pouze poslední jízdu
    const driverStats = {};

    filteredRides.forEach((ride) => {
      const { driver, tripDistance, destinationTime } = ride;

      // Pokud nemáme statistiku pro řidiče, inicializujeme
      if (!driverStats[driver]) {
        driverStats[driver] = {
          count: 0,
          totalRoundTripTime: 0,
          latestRide: null, // Zde uchováváme poslední jízdu
          completionTime: null,
        };
      }

      // Přidáme jízdu do počtu a spočítáme celkový čas tam a zpět, pokud je to poslední jízda
      if (
        !driverStats[driver].latestRide ||
        new Date(destinationTime) > new Date(driverStats[driver].latestRide.destinationTime)
      ) {
        driverStats[driver].count = 1; // Ponecháme pouze poslední jízdu, takže vždy bude 1
        driverStats[driver].totalRoundTripTime = calculateRoundTripTime(tripDistance);
        driverStats[driver].latestRide = ride; // Aktualizujeme poslední jízdu
      }
    });

    // Spočítáme čas, kdy bude mít řidič hotovo, a převedeme na požadovaný formát
    Object.keys(driverStats).forEach((driver) => {
      const latestRideTime = driverStats[driver].latestRide.destinationTime;
      const totalRoundTripTime = driverStats[driver].totalRoundTripTime; // Převedeme čas do minut

      // Přičteme celkový čas tam a zpět (v minutách) k poslední jízdě
      const completionDate = addMinutesToDate(latestRideTime, totalRoundTripTime);

      // Převedeme completionDate na formát "HH:MM DD.MM.YYYY"
      const formatedDateResult = formatDate(completionDate)
      driverStats[driver].completionTime = formatedDateResult;
      driverStats[driver].timeLeft = getMinutesRemaining(formatedDateResult) > 0 ? getMinutesRemaining(formatedDateResult) : 0
    });

    return driverStats;
  };

  export default calculateDriverStats;